import styled from 'styled-components';
// import { PRIMARY_COLOR } from './../constants/color';


export const ModuleWrapper: any = styled.div`
  
    .borderRadius, .borderRadius fieldset{
        border-radius: 20px !important;
    }

    .borderRadius>div>div:first-child {
        padding: 10px 25px;
    }

    .cluster{
        border-left: 4px solid #bdbdbd;
        border-right: none;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #ccc;
        margin-bottom: 30px;
        padding: 15px 30px;
    }

    .cluster1{
        border-left: 4px solid #bdbdbd;
        border-right: none;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #ccc;
        margin-bottom:30px;
        padding: 15px 30px 0 30px;
    }

`;


// WEBPACK FOOTER //
// ./src/styles/modules.tsx